"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TermsContainer = _interopRequireDefault(require("./TermsContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _TermsContainer.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/terms/index.js
// module id = 265
// module chunks = 0